import React from "react";
import subscriptionApi from "../../../utils/api/subscription";

interface CustomURLProps {
  input: string;
  setInput: React.Dispatch<React.SetStateAction<string>>;
  isAvailable: boolean | undefined;
  setIsAvailable: React.Dispatch<React.SetStateAction<boolean | undefined>>;
}

const CustomURL: React.FC<CustomURLProps> = ({ input, setInput, isAvailable, setIsAvailable }) => {
  const onSubmitHandler = async (event: any) => {
    event.preventDefault();

    const x = await subscriptionApi.domainAvailabilityCheck(input)

    if (x === true) {
      setIsAvailable(true)
    }
    else {
      setIsAvailable(false)
    }
  }

  const onInputChange = (e: any) => {
    let val = e.target.value.replace(/\.sw2.net$/i, "");

    val = val.toLowerCase().replace(/[^a-z0-9-]/g, "");

    setInput(val)
  };

  const availableStatus = () => {
    if (isAvailable === true) {
      return <p className="col-primary">Available</p>
    }
    else if (isAvailable === false) {
      return <p className="col-danger">Not Available</p>
    }
    else {
      return <></>
    }
  }

  return (
    <div className="custom-url__wrapper">
      <div className="custom-url">
        <h3>Custom URL</h3>
        <hr />
        <h3>Find a Perfect Custom URL</h3>
        <form onSubmit={onSubmitHandler}>
          <div className="input-wrapper">
            <input onChange={(e) => onInputChange(e)} value={input} />
            <span className="suffix">.sw2.net</span>
          </div>
          <button disabled={input === '' ? true : false}>Check Availability</button>
        </form>
        {availableStatus()}
        <h5>Example: company.sw2.net</h5>
      </div>
    </div>
  );
};

export default CustomURL;
